import React from 'react'

interface DiscoverIconProps {
  width?: number
  height?: number
  className?: string
}

const DiscoverIcon: React.FC<DiscoverIconProps> = ({
  width = 35,
  height = 24,
  className = '',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 35 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="0.5"
        y="0.5"
        width="34"
        height="23"
        rx="3.5"
        fill="white"
        stroke="#D9D9D9"
      />
      <g transform="translate(3, 8)">
        <path
          d="M11 14L30 8.25V11C30 12.6569 28.6569 14 27 14H11Z"
          fill="#FD6020"
        />
        <path
          d="M11.1846 0.110877C11.5504 0.110877 11.9686 0.164535 12.2822 0.379431V1.45365C12.0209 1.13141 11.6026 0.916541 11.1846 0.916541C10.3484 0.970305 9.66942 1.72295 9.72168 2.58256V2.68998C9.7218 3.5495 10.4011 4.19388 11.2373 4.19388C11.6553 4.19375 12.021 3.97904 12.2822 3.65678V4.73099C11.9165 4.89212 11.5508 4.99948 11.1328 4.99955C9.82628 4.99955 8.78042 3.8719 8.78027 2.52885C8.78027 1.13197 9.82573 0.00347464 11.1846 0.110877ZM19.3906 3.33451L20.6445 0.110877H21.585L19.6514 4.99955H19.1807L17.2471 0.110877H18.1885L19.3906 3.33451ZM7.00391 0.00345491C7.47414 0.00358773 7.94481 0.218302 8.31055 0.540564L7.83984 1.1851C7.63091 0.97034 7.36955 0.809283 7.1084 0.809119C6.7949 0.755408 6.53284 1.02399 6.48047 1.34623C6.48047 1.61486 6.63751 1.72312 7.16016 1.93803C8.2054 2.36783 8.46727 2.6898 8.51953 3.33451V3.49564C8.46727 4.35527 7.78741 4.99956 6.95117 4.94584C6.32401 4.94583 5.6964 4.62374 5.38281 4.03275L5.95801 3.44193C6.1148 3.81802 6.4813 4.08646 6.89941 4.08646H6.95117C7.26476 4.08646 7.57811 3.7643 7.57812 3.38822C7.57812 3.17345 7.47401 3.01228 7.31738 2.90482C7.10832 2.79737 6.89851 2.68999 6.68945 2.63627C5.85347 2.36764 5.59277 1.99087 5.59277 1.34623V1.29252C5.64521 0.540513 6.27232 -0.0502634 7.00391 0.00345491ZM1.56836 0.110877C2.82252 0.164824 3.81495 1.23954 3.7627 2.52885C3.76262 3.22714 3.44927 3.87155 2.92676 4.35502C2.45638 4.7311 1.88155 4.94585 1.30664 4.89213H0V0.110877H1.56836ZM5.01758 4.89213H4.12891V0.110877H5.01758V4.89213ZM24.5117 0.916541H22.8916V1.99174H24.46V2.7974H22.8916V4.08646H24.5117V4.89213H22.0039V0.110877H24.5117V0.916541ZM26.3936 0.110877C27.4387 0.110884 28.0135 0.594279 28.0137 1.50736C28.0659 2.2057 27.5958 2.79724 26.9688 2.90482L28.3799 4.89213H27.2822L26.0801 2.95853H25.9756V4.89213H25.0869V0.110877H26.3936ZM1.14941 0.916541H0.888672V4.08646H1.14941C1.56746 4.14018 2.03797 3.97903 2.35156 3.71049C2.66509 3.38819 2.8222 2.95855 2.82227 2.47513C2.82227 2.04532 2.66515 1.61488 2.35156 1.29252C2.03797 1.02407 1.56737 0.862835 1.14941 0.916541ZM25.9756 2.314H26.2363C26.8112 2.314 27.0732 2.0446 27.0732 1.56107C27.0731 1.13152 26.811 0.86283 26.2363 0.86283H25.9756V2.314Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.9476 0C13.641 0 12.5435 1.07454 12.5435 2.47144C12.5435 3.81461 13.5888 4.94288 14.9476 4.99661C16.3065 5.05033 17.3518 3.92207 17.4041 2.52517C17.3518 1.12827 16.3065 0 14.9476 0V0Z"
          fill="#FD6020"
        />
      </g>
    </svg>
  )
}

export default DiscoverIcon
